import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useQuery } from "@msuite/ui/query";
import { Fragment, responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { AbsencesOverviewModal } from "@/modals/users/absences-overview-modal";

/** Props Interface */
interface UserCardAbsenceIndicatorProps {
	userId: string;
	targetDate: string;
}

export function UserCardAbsenceIndicator({ userId, targetDate }: UserCardAbsenceIndicatorProps) {
	/** Hooks */
	const disclosure = useDisclosure();

	/** Query */
	const { data, isLoading } = useQuery({
		queryKey: ["user", "active-absence", targetDate, userId],
		queryFn: async () => {
			const response = await client.users[":userId"].absences.active.$get({
				param: { userId },
				query: { date: targetDate },
			});
			const data = await responseHandler(response);
			return data.absences;
		},
	});

	/** Guard */
	if (!isLoading && !guardArray(data).length) return null;

	/** Render */
	return (
		<Fragment>
			<div className="ml-auto -my-3 -mr-2">
				<Button
					size="xxs"
					variant={isLoading ? "ghost" : "danger-ghost"}
					isLoading={isLoading}
					icon={<Icon name="Pause" />}
					stopPropagation
					onClick={disclosure.onOpen}
				/>
			</div>
			{disclosure.isOpen && (
				<AbsencesOverviewModal
					onClose={disclosure.onClose}
					isOpen={disclosure.isOpen}
					userId={userId}
					targetDate={targetDate}
				/>
			)}
		</Fragment>
	);
}
